import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  quantityUpdatedAlert: {
    id: 'quantityUpdatedAlert',
    defaultMessage: 'You now have {quantity} {itemName} in your cart.',
    description:
      'Screen reader alert when a user updates the quantity of item they have in their cart.'
  },
  addOneName: {
    id: 'addOneName',
    defaultMessage: 'Add one {name}',
    description: 'Screen reader messages when a user focuses the add one item button'
  },
  removeOneName: {
    id: 'removeOneName',
    defaultMessage: 'Remove one {name}',
    description: 'Screen reader messages when a user focuses the remove one item button'
  }
});
